import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  part,
  workOrder,
  vendor,
  customer,
  team,
  user,
  asset,
  workOrderCategory,
  workOrderRequestComment,
} from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  generateLocationToArray,
  getRequestStatusColor,
  getStatusColor,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";
import ImageViewer from "../../components/ImageViewer";
import { format } from "date-fns";
import { data } from "jquery";
import Dropdown from 'react-bootstrap/Dropdown';
import { TaskAction } from "../../components/TaskAction";
import { InventorySelector } from "../../components/InventorySelector";
import { CardFooter, Modal } from "react-bootstrap";

function WorkOrderDetailRequest() {
  const { id } = useParams();
  const {authUser} = useAuth()
  const editMode = !!id;
  const [status, setStatus] = useState('')
  const [openApproveConfirmation, setOpenApproveConfirmation] = useState(false)
  const [openDeclineConfirmation,setOpenDeclineConfirmation] = useState(false)
  const [comments, setComments] = useState([])
  const [commentText,setCommentText] = useState('')

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingComment,setIsLoadingComment] = useState(false)
  const [assignType, setAssignType] = useState("individual");
  const [dataToSend, setDataToSend] = useState({
    asset_id: "",
    start_date: "",
    due_date: "",
    status: "",
    description: "",
    title: "",
    recurring_wo: "",
    priority: "medium",
    assigned_to: "",
    team_id: "",
    vendor_id: "",
    category_id: "",
    tasks: [],
    inventories:[]
  });
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }

  async function getMasterData() {
    setIsLoading(true)
    try {

      if (editMode) {
        await getRecord()
        await getComments()
      }

    } catch (err) { }
    finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getMasterData();
  }, [id]);




  

  async function getComments() {

    const result = await workOrderRequestComment.list({
        work_order_id:id
    })
    
    if (result.ok) {
      const body = await result.json()
      setComments(body.data)
    }

  }
  

  async function getRecord() {
    const result = await workOrder.getOne(id);
   
    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        asset_id: data.asset_id,
        start_date: format(new Date(data.start_date),'yyyy-MM-dd'),
        due_date: format(new Date(data.due_date), 'yyyy-MM-dd'),
        created_at:format(new Date(data.created_at), 'yyyy-MM-dd'),
        status: data.status,
        description: data.description,
        title: data.title,
        recurring_wo: data.recurring_wo,
        priority: data.priority,
        assigned_to: data.assigned_to,
        team_id: data.team_id ||"",
        vendor_id: data.vendor_id,
        category: data.category?.name,
        vendor: data.vendor?.vendor_name,
        assigned:data.team_id?data.team?.team_name:data.assigned_to_user?.firstname,
        assignType: data.team_id ? 'Team' : 'Individual',
        asset: data.asset?.asset_name,
        tasks: data.tasks || [],
        inventories: data.inventories || [],
        created_by: data.created_by_user?.firstname,
        request_status: data.request_status,
        action_taken_by_user: data.action_taken_by_user,
        action_taken_date:data.action_taken_date?format(new Date(data.action_taken_date),'yyyy-MM-dd'):'-'
        
        
      }
      setStatus(data.request_status)
      setDataToSend(defaultValue);

    }
    
  }



  const handleChangeStatus = async (v) => {
    try {
      let result

         result = await workOrder.updateRequestStatus(id, { status: v })
      
   
      if (result.ok) {
        toast.success('Status updated')
        setOpenApproveConfirmation(false)
        setOpenDeclineConfirmation(false)
        getMasterData()
      } else {
        toast.error('Status failed to update')
      }
    } catch (e) {
      toast.error(e.message)
    }
    
  }

  const handleSendComment = async () => {
    
    if (!commentText) {
      return
    }
    try {
      let result
      setIsLoadingComment(true)

      result = await workOrderRequestComment.create({
        work_order_id: id,
        comment:commentText
         })
      
      if (result.ok) {
        getComments()
        setCommentText('')
      } else {
        toast.error('Something went wrong, please try again')
      }
    } catch (e) {
      toast.error(e.message)
    }
    finally {
      setIsLoadingComment(false)
    }
   

  }

  const handleDeleteComment = async (commentId)=>{
    try {
      let result
      setIsLoadingComment(true)

      result = await workOrderRequestComment.delete(commentId)
      
      if (result.ok) {
        getComments()
      } else {
        toast.error('Something went wrong, please try again')
      }
    } catch (e) {
      toast.error(e.message)
    }
    finally {
      setIsLoadingComment(false)
    }
   

  }

 

  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>Request Information</CardHeader>

      <CardBody>
      
        
     
        <div className="row g-3">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="workOrderTitle" className="form-label">
                Request Title
              </label>
              <input
                disabled
                value={dataToSend["title"]}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="startDate" className="form-label">
                Created Date
              </label>
              <input
                disabled
                value={dataToSend["created_at"]}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="startDate" className="form-label">
                Start Date
              </label>
              <input
                disabled
                value={dataToSend["start_date"]}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="dueDate" className="form-label">
                Due Date
              </label>
              <input
                disabled
                value={dataToSend["due_date"]}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="recurringWO" className="form-label">
                Recurring WO
              </label>
              <input
                disabled
                value={dataToSend["recurring_wo"] ||'No'}
                className="form-control"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <input
                disabled
                value={dataToSend["description"]}
                className="form-control"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="asset" className="form-label">
                Asset
              </label>
              <input
                disabled
                value={dataToSend.asset}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="priority" className="form-label">
                Priority
              </label>
              <input
                disabled
                value={dataToSend["priority"]}
                className="form-control"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="priority" className="form-label">
                Category
              </label>
              <input
                disabled
                value={dataToSend.category}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="assignee" className="form-label">
                Assignee Type
              </label>
              <input
                disabled
                value={dataToSend.assignType}
                className="form-control"
                required
              />
            </div>
          
              <div className="mb-3">
                <label htmlFor="assignee" className="form-label">
                  Assigned to
                </label>
                <input
                disabled
                value={dataToSend.assigned}
                className="form-control"
                required
              />
              </div>
          </div>

          <div className="col-md-6">

          {dataToSend.request_status != 'Pending' && 
        
        <Card style={{ marginTop: "10px" }}>
        <LoadingIndicator open={isLoading} />
        <CardHeader>Status Information</CardHeader>
            <CardBody>
            <div className="mb-3">
        <label htmlFor="assignee" className="form-label">
                  Request Status
                </label>
          <input
                disabled
                value={status}
                className="form-control"
                required
                />
              </div>
              

              <div className="mb-3">

<label htmlFor="assignee" className="form-label">
                 {status} By
                </label>
          <input
                disabled
                value={dataToSend.action_taken_by_user?.firstname}
                className="form-control"
                required
                />
              </div>
              
              <div className="mb-3">

<label htmlFor="assignee" className="form-label">
                  {status} At
                </label>
          <input
                disabled
                value={dataToSend.action_taken_date}
                className="form-control"
                required
                />
                </div>
        </CardBody>
          </Card>
          
        } 
           
          <Card style={{ marginTop: "10px",marginBottom:'10px' }}>
          <LoadingIndicator open={isLoading} />
          <CardHeader>Requester Information</CardHeader>
          <CardBody>
          <div className="mb-3">
              <label htmlFor="assignee" className="form-label">
                Submitted by
              </label>
              <input
                disabled
                value={dataToSend.created_by}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="assignee" className="form-label">
                Created at
              </label>
              <input
                disabled
                value={dataToSend.created_at}
                className="form-control"
                required
              />
            </div>
          </CardBody>
            </Card>


            
            
            <Card style={{ marginTop: "10px",marginBottom:'10px' }}>
          <LoadingIndicator open={isLoading} />
          <CardHeader>Updates</CardHeader>
              <CardBody>
                
                {comments.map((c,i) => {
                  
                  return   <div className="mb-3" key={i} style={{borderBottom:'1px solid #b6b6b6',paddingBottom:'5px'}}>
                  <div className="d-flex">
                  
                      <div style={{color:'#b6b6b6',fontSize:'12px'}}>
                      {c.created_by_user?.firstname} |  {format(new Date(c.created_at),'yyyy-MM-dd hh:mm')}
                      </div>

                      <div style={{marginLeft:'auto'}}>
                        {authUser?.username == c.created_by && <button
                          disabled={isLoadingComment}
                  onClick={() => handleDeleteComment(c.id)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-sm btn-outline-danger"
                >
                  <i className="fa fa-trash"></i>
                </button>}  
                      </div>
                


                </div>

                  <div style={{fontSize:'13px'}}>
                          {c.comment}
                  </div>
            </div>
                })}

{comments.length==0 && <div style={{marginBottom:'10px'}}>- No updates -</div>}         

            <div className="mb-3">
                  <textarea value={commentText} className="form-control" onChange={(e)=>setCommentText(e.target.value)}>
                  
                    
                  </textarea>
                  
                  <button disabled={isLoadingComment} onClick={handleSendComment} style={{marginLeft:"auto"}} className="btn btn-outline-theme mt-2">Add Comment</button>
            </div>
          </CardBody>
        </Card>
            
          </div>
        </div>


       

  <TaskAction onChange={() => { }} value={dataToSend['tasks']} />
        
    {/* <div className="mt-2">
          <InventorySelector readOnly onChange={() => { }} value={dataToSend['inventories']}/>
        </div> */}
        

        <Card style={{ marginTop: "10px" }}>
          <LoadingIndicator open={isLoading} />
          <CardHeader>More Information</CardHeader>
          <CardBody>
          <label htmlFor="assignee" className="form-label">
                  Vendor
                </label>
          <input
                disabled
                value={dataToSend.vendor}
                className="form-control"
                required
              />
          </CardBody>
        </Card>




     {dataToSend.request_status =='Pending' &&  <div className="mt-4 flex">
          <button
            className="btn btn-outline-theme btn-lg me-2"
            onClick={()=>setOpenApproveConfirmation(true)}
          >

           APPROVE
          </button>
          <button
            className="btn btn-outline-danger btn-lg me-2"
            onClick={()=>setOpenDeclineConfirmation(true)}
          >
            DECLINE
          </button>

          <button
            className="btn btn-outline-warning btn-lg"
            onClick={()=>navigate('/request/edit/'+id)}
          >
            EDIT
          </button>
        </div>}  

        


        <Modal show={openApproveConfirmation} onHide={()=>setOpenApproveConfirmation(false)} centered>
              <Modal.Body className="p-0">
                <Card>
                  <CardHeader className="p-3">
                   
                    <button
                      className="btn"
                      style={{
                        position: "absolute",
                        fontSize: 8,
                        textTransform: "uppercase",
                        right: 0,
                        top: "0",
                        bottom: "0",
                        marginTop: "auto",
                        marginBottom: "auto",
                        textDecoration: "underline",
                        minWidth: "30px",
                      }}
                      onClick={()=>setOpenApproveConfirmation(false)}
                    >
                      CLOSE
                    </button>
                  </CardHeader>
                  <CardBody>Are you sure want to approve this request? </CardBody>
                  <CardFooter>
                    <div
                      style={{
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px 0",
                      }}
                    >
                      <button
                        className="btn btn-outline-theme me-2"
                        onClick={()=>handleChangeStatus('Approved')}
                      >
                       Approve
                  </button>
                  <button
                        className="btn btn-outline-warning me-2"
                        onClick={()=>navigate('/request/edit/'+id)}
                      >
                      Edit
                      </button>
                  
                    </div>
                  </CardFooter>
                </Card>
              </Modal.Body>
            </Modal>


            <Modal show={openDeclineConfirmation} onHide={()=>setOpenDeclineConfirmation(false)} centered>
              <Modal.Body className="p-0">
                <Card>
                  <CardHeader className="p-3">
                   
                    <button
                      className="btn"
                      style={{
                        position: "absolute",
                        fontSize: 8,
                        textTransform: "uppercase",
                        right: 0,
                        top: "0",
                        bottom: "0",
                        marginTop: "auto",
                        marginBottom: "auto",
                        textDecoration: "underline",
                        minWidth: "30px",
                      }}
                      onClick={()=>setOpenDeclineConfirmation(false)}
                    >
                      CLOSE
                    </button>
                  </CardHeader>
                  <CardBody>Are you sure want to decline this request? </CardBody>
                  <CardFooter>
                    <div
                      style={{
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px 0",
                      }}
                    >
                      <button
                        className="btn btn-outline-danger me-2"
                        onClick={()=>handleChangeStatus('Declined')}
                      >
                       Decline
                  </button>
               
                  
                    </div>
                  </CardFooter>
                </Card>
              </Modal.Body>
            </Modal>
   
      </CardBody>
    </Card>
    
  );
}

export default WorkOrderDetailRequest;
